import { AbstractDocument, Timestampable, Untrackable } from '../../../abstract/Document';
import type { ISupplierAdminStripe } from './stripe.types';

@Timestampable
@Untrackable
export class AdminStripe extends AbstractDocument<ISupplierAdminStripe> {
  readonly collections = {};
}
